import BookDataTable from "../../../features/book-management/book-list/BookDataTable";
import BookFilterHeader from "../../../features/book-management/book-list/BookFilterHeader";
import { useParams } from "react-router-dom";
import { PATH } from "../../../data/router_path";
import useGetBookCollection from "../../../features/book-management/book-list/hooks/useGetBookCollection";

export default function BookPackageBooksPage() {
  const { uuid } = useParams()
  const path = PATH.BOOK.PACKAGE_BOOKS(uuid)
  const { data, isLoading } = useGetBookCollection()
  const bookCollectionName = data?.collections.find(collection => collection.uuid === uuid)?.name
  return (  
    <div className="flex flex-col">
      <BookFilterHeader title={bookCollectionName} path={path} BookPackageFilterDisplay={false}/>
      <BookDataTable path={path} />
    </div>
  )
}